import { isEmpty } from '@vxui/components';
import { FormikErrors } from 'formik';
import { t } from 'i18next';
import { Credentials } from '../models/auth';

export const validateLogin = (values: Credentials) => {
  const errors: FormikErrors<Credentials> = {};

  if (isEmpty(values.login)) errors.login = t('auth.forms.auth.fields.login.errors.empty');
  if (isEmpty(values.password)) errors.password = t('auth.forms.auth.fields.password.errors.empty');

  return errors;
};
